import { render, staticRenderFns } from "./PlanTerms.vue?vue&type=template&id=b04ea534&scoped=true"
import script from "./PlanTerms.vue?vue&type=script&lang=js"
export * from "./PlanTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04ea534",
  null
  
)

export default component.exports